/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/uploadLogsLists.config.json";
// import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_TRACKER } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

import moment from "moment";
import { toHeaderCase } from "js-convert-case";

export interface IDownloadTrackerEventMethods extends IPluginMethodMap {
  getDownloadTrackerEventProps(args: any): Promise<any>;
}

export interface IGetTrackerEventProps {
  trackerId: string;
}

const lookup = require("country-code-lookup");

export class DownloadTrackerEventService implements IAgentPlugin {
  readonly methods: IDownloadTrackerEventMethods;

  constructor() {
    this.methods = {
      getDownloadTrackerEventProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetTrackerEventProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_TRACKER,
          variables: {
            getTrackerId: args?.trackerId,
          },
          fetchPolicy: "network-only",
        });

        const logs = res?.data?.getTracker?.logs || [];

        return {
          ultTableHeader: await this.getRowData(),
          ultUsers: this.formatTable(logs),
          isEmpty: logs.length <= 0,
        };
      }
    } catch (err) {
      console.error("Tracker Logs Error:", err);
      return {
        isEmpty: true,
      };
    }
  }

  private async getRowData() {
    return [
      { key: "email", label: "Email" },
      { key: "status", label: "Status" },
      { key: "error", label: "Error" },
      { key: "trackerId", label: "Tracker ID" },
    ];
  }

  private formatTable(logs: any[]) {
    if (!Array.isArray(logs)) return [];

    return logs.map((log: any) => ({
      email: log?.email,
      status: log?.job_result,
      error: log?.job_error || "NA",
      trackerId: log?.tracker_id,
    }));
  }
}
